import { useEffect, useRef } from 'react';
import { useFormInitContext } from '../../../../hooks/context/useFormInitContext';

// Registers this component with FormInitProvider and signals when initialization
// is done. No-op if `pending` is false on mount (no async work needed).
export const useFormInitRegistration = (pending: boolean) => {
  const { register } = useFormInitContext();
  const markReadyRef = useRef<(() => void) | null>(null);
  // Capture pending at mount time — only register if the component starts as pending.
  const initialPendingRef = useRef(pending);

  useEffect(() => {
    if (!initialPendingRef.current) return;
    markReadyRef.current = register();
    return () => {
      // Unmounted before resolved → release so the context doesn't block forever.
      markReadyRef.current?.();
      markReadyRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!pending && markReadyRef.current) {
      markReadyRef.current();
      markReadyRef.current = null;
    }
  }, [pending]);
};
